import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { InnerPackageQuantityRequired, OrderEntry, PrePrintedLabel } from '../../../../core/model';
import { Occ } from '../../../../core/occ';
import { ConverterService } from '../../../../core/util';
import { PRE_PRINTED_LABEL_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class CartEntryPrePrintedLabelConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  loadOptions(userId: string, cartId: string, entry: OrderEntry): Observable<PrePrintedLabel[]> {
    const url = this.occEndpointsService.buildUrl('prePrintedLabelOptions', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });

    return this.httpClient.get<Occ.PrePrintedLabel[]>(url).pipe(this.converterService.pipeableMany(PRE_PRINTED_LABEL_NORMALIZER));
  }

  loadInnerPackageQuantityRequired(userId: string, cartId: string, entry: OrderEntry): Observable<InnerPackageQuantityRequired> {
    const url = this.occEndpointsService.buildUrl('prePrintedLabelInnerPackageQuantityRequired', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });

    return this.httpClient.get<InnerPackageQuantityRequired>(url);
  }

  update(userId: string, cartId: string, entry: OrderEntry, option: PrePrintedLabel): Observable<any> {
    const url = this.occEndpointsService.buildUrl('prePrintedLabels', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.post(url, option);
  }

  delete(userId: string, cartId: string, entry: OrderEntry): Observable<any> {
    const url = this.occEndpointsService.buildUrl('prePrintedLabels', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.delete(url);
  }
}
